var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInNewWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408:33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.76 12H22.08C21.948 12 21.84 12.108 21.84 12.24V21.84H2.16V2.16H11.76C11.892 2.16 12 2.052 12 1.92V0.24C12 0.108 11.892 0 11.76 0H0.96C0.429 0 0 0.429 0 0.96V23.04C0 23.571 0.429 24 0.96 24H23.04C23.571 24 24 23.571 24 23.04V12.24C24 12.108 23.892 12 23.76 12Z",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3638 0.25C15.3638 0.111929 15.4757 0 15.6138 0H23.4998C23.6236 0 23.737 0.0450267 23.8243 0.119603C23.9074 0.190525 23.9669 0.288173 23.9896 0.399233C23.9963 0.431785 23.9998 0.465489 23.9998 0.50001V8.38299C23.9998 8.52272 23.8865 8.63599 23.7468 8.63599H22.2111C22.0714 8.63599 21.9581 8.52272 21.9581 8.38299V3.62939L12.9402 12.6474C12.8425 12.745 12.6842 12.745 12.5866 12.6474L11.3479 11.4086C11.2503 11.311 11.2503 11.1527 11.3479 11.0551L20.3613 2.04166H15.6138C15.4757 2.04166 15.3638 1.92973 15.3638 1.79166V0.25Z",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408:33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNewWindow);
export default __webpack_public_path__ + "static/media/open_in_new_window.f17b23186186f1efdc9a02058bd4e7c7.svg";
export { ForwardRef as ReactComponent };